import React from 'react';

import type { ControllerFieldState } from 'react-hook-form';

import { TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';

interface Props extends Omit<TextFieldProps, 'error' | 'inputProps' | 'onChange' | 'sx' | 'type'> {
  fieldState: ControllerFieldState;
  onChange: (value: number | undefined) => void;
}

export default function TourPercentagePriceField({ fieldState, onChange, ...props }: Props) {
  return (
    <TextField
      {...props}
      type="number"
      error={fieldState.invalid}
      onChange={(event) => {
        const value = event.target.value != '' ? Number(event.target.value) : undefined;
        onChange(value);
      }}
      sx={{ width: 80 }}
      inputProps={{ step: 0.01, min: 0, max: 1 }}
    />
  );
}
